import React, { Component } from "react";
import "./TopButton.css";

class TopButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_visible: false,
    };
  }

  // This lifecycle method runs when the component is added to the page
  componentDidMount() {
    window.addEventListener("scroll", this.toggleVisibility);
  }

  // This lifecycle method runs when the component is about to be removed
  componentWillUnmount() {
    window.removeEventListener("scroll", this.toggleVisibility);
  }

  // This function checks the scroll position and updates the component's state
  toggleVisibility = () => {
    if (window.pageYOffset > 300) { // Show button after scrolling 300px
      this.setState({
        is_visible: true,
      });
    } else {
      this.setState({
        is_visible: false,
      });
    }
  };

  // This function scrolls the page to the top
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  render() {
    const { is_visible } = this.state;
    const theme = this.props.theme;
    return (
      <div className="top-button-container">
        {is_visible && (
          <div
            onClick={this.scrollToTop}
            className="top-button"
            style={{
              backgroundColor: theme.body,
              color: theme.text,
              border: `1px solid ${theme.text}`
            }}
          >
            <i className="fas fa-arrow-up" aria-hidden="true" />
          </div>
        )}
      </div>
    );
  }
}

export default TopButton;